"use strict"

import React from "react"

import FavouritesSelector from "../../favourites/FavouritesSelector"
import { ZoomInButton, ZoomOutButton } from "../../graphing/zooming/ZoomControlsPopover"
import NewPlotButton from "../../graphing/plotting/widgets/NewPlotButton"

import DefaultGraphConfigButton from "../../graphing/resources/DefaultGraphConfigButton"
import FontEditPopover from "../../graphing/plotting/widgets/FontEditPopover"
import { multi_run_view as registration } from "../../../components/shared_components_registration"
const { SettingsButtons } = registration

export default function PlotToolBar({
  plotList,
  updateGraphs,
  siteReactors = [],

  //   Needed for FavouritesSelector
  graphs = [],
  runs = [],
  updateRunList = () => {},
  //   --- Needed for FavouritesSelector

  showNewGraph = true,
  showConfigRestore = true,
  showFavorites = true,
  showZoomOptions = true,
  extraContent = <></>,
  allowScaleToggle = true,
  allowAlignToggle = true,
  showSettings = true,
  showFontEditor = true,

  intl,
}) {
  return (
    <div
      style={{
        flex: "40px 0 0",
        alignSelf: "flex-start",
        display: "flex",
        flexDirection: "column",
        position: "absolute",
        right: registration.toolbar_right_px || "30px",
        zIndex: "300",
        backgroundColor: "white",
      }}
    >
      {showNewGraph && (
        <NewPlotButton
          btnText={false}
          plotList={plotList}
          updatePlots={updateGraphs}
          intl={intl}
          placement={"left"}
          siteReactors={siteReactors}
        />
      )}

      {showConfigRestore && <DefaultGraphConfigButton intl={intl} button={true} type={"graphs"} />}

      {showFavorites && (
        <FavouritesSelector
          runs={runs}
          view={"Standard"}
          graphSet={graphs}
          loadGraphSet={updateGraphs}
          updateRunList={updateRunList}
          intl={intl}
          should_match_view={false}
          dropToggleClass={"width-100"}
        />
      )}

      {showZoomOptions && (
        <>
          <ZoomInButton intl={intl} />
          <ZoomOutButton intl={intl} />
        </>
      )}

      {showSettings && (
        <SettingsButtons
          intl={intl}
          allowScaleToggle={allowScaleToggle}
          allowAlignToggle={allowAlignToggle}
        />
      )}

      {showFontEditor && <FontEditPopover intl={intl} />}

      {extraContent && extraContent}
    </div>
  )
}
